import { DriveInput, DriverDetails } from "../../types";

export const standardDriverData = (
  title: string,
  stepsData: DriveInput[],
  zeroItemId: string,
  customMenuTitle?: string,
) => {
  const details: DriverDetails = {
    driverMenuItemTitle: customMenuTitle ?? title,
    driverData: {
      driverHeader: title,
      stepsData: stepsData,
    },
    steps: stepsData.map(({ step, description }) => step ?? description),
  };

  details.driverData.stepsData[0].anchorElement = `#${zeroItemId}`;
  return details;
};
